import React from 'react';
import { IPointOfSaleSettingsProps } from 'components/settings/PointOfSaleSettings';
import { TextFormField } from 'lib/form/fields/TextFormField';
import { SettingDisplay } from 'lib/SettingDisplay';
import { PasswordFormField } from 'lib/form/fields/PasswordFormField';
import { AutocompleteFormField } from 'lib/form/fields/AutocompleteFormField';

export enum QikserveOrderType {
    Delivery = 'DELIVERY',
    DineIn = 'DINEIN',
    DriveThru = 'DRIVE_THRU',
    OrderAtTable = 'ORDER_AT_TABLE',
    TakeOut = 'TAKE_OUT',
    UberDirect = 'UBER_DIRECT'
}

export const menuOrderTypeLabels = {
    [QikserveOrderType.TakeOut]: 'Takeout',
    [QikserveOrderType.DineIn]: 'Dine In',
    [QikserveOrderType.OrderAtTable]: 'Order to Table',
    [QikserveOrderType.Delivery]: 'Delivery',
    [QikserveOrderType.DriveThru]: 'Drive Thru',
    [QikserveOrderType.UberDirect]: 'Uber Direct'
};

const menuOrderTypesOptions = [
    { label: menuOrderTypeLabels[QikserveOrderType.TakeOut], value: QikserveOrderType.TakeOut },
    { label: menuOrderTypeLabels[QikserveOrderType.DineIn], value: QikserveOrderType.DineIn },
    { label: menuOrderTypeLabels[QikserveOrderType.OrderAtTable], value: QikserveOrderType.OrderAtTable },
    { label: menuOrderTypeLabels[QikserveOrderType.Delivery], value: QikserveOrderType.Delivery },
    { label: menuOrderTypeLabels[QikserveOrderType.DriveThru], value: QikserveOrderType.DriveThru },
    { label: menuOrderTypeLabels[QikserveOrderType.UberDirect], value: QikserveOrderType.UberDirect }
];

export const QikserveSettingsEdit: React.FC<IPointOfSaleSettingsProps> = ({ locationId }) => (
    <>
        {/* Common Only */}
        {locationId === undefined && (
            <>
                <SettingDisplay label="Host">
                    <TextFormField name="qikserveConnectHost" />
                </SettingDisplay>
                <SettingDisplay label="API Key">
                    <PasswordFormField name="qikserveConnectApiKey" />
                </SettingDisplay>
                <SettingDisplay label="Client ID">
                    <TextFormField name="qikserveConnectClientId" />
                </SettingDisplay>
                <SettingDisplay label="Client Secret">
                    <PasswordFormField name="qikserveConnectClientSecret" />
                </SettingDisplay>
                <SettingDisplay label="Market Name">
                    <TextFormField name="qikserveConnectMarketName" />
                </SettingDisplay>
                <SettingDisplay label="Locale">
                    <TextFormField name="qikserveConnectLocale" />
                </SettingDisplay>
                <SettingDisplay label="Menu Order Types">
                    <AutocompleteFormField
                        name="qikserveConnectMenuOrderTypes"
                        multiple
                        options={menuOrderTypesOptions}
                    />
                </SettingDisplay>
            </>
        )}
        {/* Location Only */}
        {locationId !== undefined && (
            <SettingDisplay label="Store Number">
                <TextFormField type="number" name="qikserveConnectStoreNumber" />
            </SettingDisplay>
        )}
    </>
);
